import { HStack, PinInput, PinInputField } from '@chakra-ui/react';
import { useCallback, useMemo } from 'react';

const pinInputStyle = {
  width: '2.5ch',
  height: '2.5ch',
  margin: '0 0.1rem',
  fontSize: '3rem',
  fontFamily: 'monospace',
};

export function OTPInput({
  slots = 4,
  onSubmit,
  onOtpInputChange,
}: {
  slots?: number;
  onSubmit: (otp: string) => void;
  onOtpInputChange: (otp: string) => void;
}) {
  const handleComplete = useCallback(
    (value: string) => {
      onOtpInputChange(value);
      onSubmit(value);
    },
    [onSubmit, onOtpInputChange],
  );

  const handleChange = useCallback(
    (value: string) => {
      onOtpInputChange(value);
    },
    [onOtpInputChange],
  );

  const pinInputKeys = useMemo(() => {
    return Array.from({ length: slots }, (_, i) => `pin-${i}`);
  }, [slots]);

  return (
    <HStack>
      <PinInput
        type="number"
        otp
        autoFocus
        focusBorderColor="border.accent"
        placeholder=""
        onComplete={handleComplete}
        onChange={handleChange}
      >
        {pinInputKeys.map((key) => (
          <PinInputField key={key} style={pinInputStyle} />
        ))}
      </PinInput>
    </HStack>
  );
}
